<template>
  <form @submit.prevent="submit">
    <PageHeader>
      <div class="heading">
        <h1>
          Custom Website CSS
        </h1>
      </div>
    </PageHeader>

    <div class="css-textarea">
      <Field
        label="Custom CSS"
        type="textarea"
        @input="$v.resource.css.$touch()"
        @handleChange="handleChange"
        v-model="resource.css"
        :disableEditor="true"
        :error="cssError"/>

      <div class="btn-save">
        <Btn :class="{'changes-made': changesMade}">Save Changes</Btn>
      </div>
    </div>
  </form>
</template>

<script>
import form from '@/mixins/form'

import Btn from '@/components/Btn'
import PageHeader from '@/components/PageHeader'

import {errorMessages} from '@/lib/error_messages'

export default {
  name: 'CustomCssForm',

  mixins: [form],

  components: {
    Btn,
    PageHeader
  },

  computed: {
    ...errorMessages([
      'css'
    ])
  },

  validations: {
    resource: {
      css: {}
    }
  }
}
</script>

<style lang="sass">
  .css-textarea
    textarea
      min-height: 55vh
      resize: vertical
</style>
